import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate';
export default createStore({
  state: {
    token: '',
    user:{}
  },
  getters: {
  },
  mutations: {
    setToken(state, e) {
      state.token = e
    },
    setUserData(state, e) {
      state.user = e;
    },
    clearStore(state) {
      state.user = {};
      state.token = ''
      /* sessionStorage.clear()
      localStorage.clear() */
    }
  },
  actions: {
    setToken(storage, e) {
      storage.commit('setToken', e);
    },
    setUserData(storage, e) {
      storage.commit('setUserData', e);
    },
    clearStore(storage) {
      storage.commit('clearStore');
    }
  },
  modules: {
  },
  //持久化数据
  plugins: [
    createPersistedState({
      key: 'vuex',
      //可选，sessionStorage/indexDB/localStorage
      storage: window.localStorage
    })
  ]
})
